import { StyledActivity, StyledCategory, StyledWrapper } from './labeled-activity.styles';
import type { LabeledActivityProps } from './labeled-activity.types';
export const LabeledActivity = ({
  activity
}: LabeledActivityProps) => <StyledWrapper data-sentry-element="StyledWrapper" data-sentry-component="LabeledActivity" data-sentry-source-file="labeled-activity.tsx">
    <StyledActivity data-sentry-element="StyledActivity" data-sentry-source-file="labeled-activity.tsx">
      <p>
        {activity.source}: {activity.action}
      </p>
    </StyledActivity>

    <StyledCategory data-sentry-element="StyledCategory" data-sentry-source-file="labeled-activity.tsx">
      <p>{activity.categories.join(', ')}</p>
    </StyledCategory>
  </StyledWrapper>;